import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_10.jpg'
import { IPageResponse } from '../../../models/Pages'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Page } from '../../templates/Page'

const FundScreen = () => {
  const i18n = useRecoilValue(translate).fund
  const breadcrumbs = [
    {
      link: routes.fund,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IPageResponse>(URI.getPageUri('westminster-one', lang))

  return (
    <>
      <ImageSection id={'fund'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data.length && <Page data={data.data[0]} />}
      </PageWrapper>
    </>
  )
}

export default FundScreen
